import { readString } from "app-base/runtime/storage"

export function localStorageValue(key: string): string | undefined {
  return readString(key, { storage: localStorage }) || undefined;
}

export function localStorageId(key: string): number | undefined {
  const stored = localStorageValue(key);
  if (stored) {
    const id = parseInt(stored);
    if (!isNaN(id)) {
      return id;
    }
  }
  return undefined;
}
